/**
 * nova-editorial-scroll.js
 * assets/nova-editorial-scroll.js
 *
 * UPDATED: Animation runs on desktop only (>= MOBILE_BP).
 * On mobile, transform is reset to none and no scroll listener fires.
 */

(function () {
  'use strict';

  var MAX_X         = 60;
  var MAX_Y         = 80;
  var DESKTOP_RANGE = 400;
  var MOBILE_BP     = 951;

  function findScrollContainer(el) {
    var node = el.parentElement;
    while (node && node !== document.body) {
      var style    = getComputedStyle(node);
      var overflow = style.overflow + style.overflowY;
      if (/auto|scroll/.test(overflow)) return node;
      node = node.parentElement;
    }
    return window;
  }

  function getScrollY(container) {
    return container === window
      ? (window.scrollY || window.pageYOffset)
      : container.scrollTop;
  }

  function init() {
    var sections = document.querySelectorAll('.nova-editorial-scroll');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var mediaBlock = section.querySelector('.media-block');
      if (!mediaBlock) return;

      var scrollContainer = findScrollContainer(section);
      var applying        = false;

      /* MutationObserver — re-applies after Horizon resets the style */
      var observer = new MutationObserver(function () {
        if (applying) return;
        applyTransform();
      });
      observer.observe(mediaBlock, { attributes: true, attributeFilter: ['style'] });

      function applyTransform() {
        /* ── MOBILE: reset to natural position, do nothing ── */
        if (window.innerWidth < MOBILE_BP) {
          applying = true;
          mediaBlock.style.setProperty('transform', 'none', 'important');
          applying = false;
          return;
        }

        /* ── DESKTOP: scroll-driven animation ── */
        var scrollY  = getScrollY(scrollContainer);
        var progress = Math.min(Math.max(scrollY / DESKTOP_RANGE, 0), 1);
        var eased    = 1 - Math.pow(1 - progress, 2);
        var x        = (MAX_X * (1 - eased)).toFixed(1);
        var y        = (MAX_Y * (1 - eased)).toFixed(1);

        applying = true;
        mediaBlock.style.setProperty('transform', 'translate(' + x + 'px,' + y + 'px)', 'important');
        applying = false;
      }

      /* Set initial state */
      if (window.innerWidth >= MOBILE_BP) {
        mediaBlock.style.setProperty('transform', 'translate(' + MAX_X + 'px,' + MAX_Y + 'px)', 'important');
        mediaBlock.style.willChange = 'transform';
      }

      applyTransform();

      var ticking = false;
      scrollContainer.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            applyTransform();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });

      /* On resize — re-evaluate (e.g. rotating from portrait to landscape) */
      window.addEventListener('resize', function () {
        if (window.innerWidth < MOBILE_BP) {
          /* Entering mobile — clear everything */
          applying = true;
          mediaBlock.style.setProperty('transform', 'none', 'important');
          mediaBlock.style.willChange = 'auto';
          applying = false;
        } else {
          /* Entering desktop — restore will-change and recalculate */
          mediaBlock.style.willChange = 'transform';
          applyTransform();
        }
      }, { passive: true });
    });
  }

  function waitAndInit() {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(init);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

})();